import React, { useState } from 'react';
import './App.css';
import GenerateQR from './components/GenerateQR';
import ScanQR from './components/ScanQR';

function App() {
  const [activeTab, setActiveTab] = useState('generate');

  return (
    <div className="App">
      <header className="app-header">
        <div className="header-content">
          <div className="logo-title">
            <img src="/logo.png" alt="UB-QR Logo" className="app-logo" />
            <h1>UB-QR</h1>
          </div>
          <p className="tagline">Generate, Customize, Scan & Download QR Codes</p>
        </div>
      </header>

      <nav className="app-nav">
        <button
          className={activeTab === 'generate' ? 'active' : ''}
          onClick={() => setActiveTab('generate')}
        >
          ✨ Generate QR
        </button>
        <button
          className={activeTab === 'scan' ? 'active' : ''}
          onClick={() => setActiveTab('scan')}
        >
          🔍 Scan QR
        </button>
      </nav>

      <main className="app-main">
        {activeTab === 'generate' ? <GenerateQR /> : <ScanQR />}
      </main>

      <footer className="app-footer">
        <p>UB-QR © 2025 - Fully Client-Side QR Code Tool</p>
        <p className="privacy-note">🔒 All operations are performed locally in your browser. No data is sent to any server.</p>
      </footer>
    </div>
  );
}

export default App;
